import { useState } from "react";
import { Input } from "./ui/input";

const fmt = (v) => {
  if (v === "" || v == null) return "";
  const n = Number(v);
  if (!Number.isFinite(n)) return "";
  const [i, d] = Math.abs(n).toFixed(2).split(".");
  return `${n < 0 ? "-" : ""}${i.replace(/\B(?=(\d{3})+(?!\d))/g, ".")},${d}`;
};

// Campo euro per valori salvati con il punto decimale: mostra "1.234,50 €" fuori dal focus, digitazione libera durante il focus.
export const EuroDotInput = ({ value, onChange, readOnly, className = "", testId, placeholder = "0,00", title }) => {
  const [focus, setFocus] = useState(false);
  const [buf, setBuf] = useState("");
  return (
    <div className="relative">
      <Input type="text" inputMode="decimal" readOnly={readOnly} tabIndex={readOnly ? -1 : undefined} title={title}
        value={focus && !readOnly ? buf : fmt(value)} placeholder={placeholder}
        onFocus={() => { if (!readOnly) { setBuf(fmt(value).replace(/\./g, "")); setFocus(true); } }}
        onBlur={() => setFocus(false)}
        onChange={(e) => { const s = e.target.value.replace(/[^\d,.-]/g, ""); setBuf(s); onChange?.(s.replace(/\./g, "").replace(",", ".")); }}
        data-testid={testId} className={`pr-6 text-right font-mono ${className}`} />
      <span className="pointer-events-none absolute right-2 top-1/2 -translate-y-1/2 text-xs text-slate-400">€</span>
    </div>
  );
};
